<template>
  <div class="el-main" v-loading.fullscreen.lock="fullscreenLoading" :element-loading-text="loadingText">

    <div class="card" v-show="currentCardId == 'edu-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>学歴を入力</h2>
          <p>「自動入力」を使うと、入学・卒業年度を自動で計算できます</p>
          <el-checkbox v-model="formatData.notDisplayIjyo">【以上】を表示しない</el-checkbox>
        </div>
        <div class="card-content-list">
          <div class="add-item">
            <div class="edu-history-action">
              <auto-educational-backgrounds v-on:create-educational-background="setEducationalBackgrounds"
                :year="basicData.birthYear" :month="basicData.birthMonth"
                :day="basicData.birthDay"></auto-educational-backgrounds>
              <div class="button-reset">
                <el-button v-if="formatData.educationalHistories && formatData.educationalHistories.length > 1"
                  @click="$modal.show('educational-reset')">リセット</el-button>
              </div>
              <modal name="educational-reset" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('educational-reset');" icon="el-icon-close" type="text"></el-button>
                </div>
                <div class="title">学歴リセット</div>
                <span>入力されている学歴をすべて削除します。よろしいですか？</span>

                <div class="text-left">
                  <el-button type="primary"
                    @click="$modal.hide('educational-reset'); resetEducationalBackgrounds()">リセットする</el-button>
                  <el-button @click="$modal.hide('educational-reset')">リセットしない</el-button>
                </div>
              </modal>

            </div>
          </div>

          <div class="edit-form-item" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
            <div class="item-name">卒業予定</div>
            <div class="item-body">
              <el-select v-model="formatData.gradeYear" placeholder="選択してください">
                <el-option v-for="item in gradeYearOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addEducationalHistory"
                v-on:delete-history-item="deleteEducationalHistory" v-on:move-history-item="moveEducationalHistory"
                v-for="(item, index) in formatData.educationalHistories" @click.native="activateHistoryItem(item.uuid)"
                :item="item" :length="formatData.educationalHistories.length" :index="index" :key="item.uuid"
                :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }" :minYear="basicData.birthYear"
                :ref="'EducationalHistory_' + index" :createDate="formatData.createDate"
                :descriptionPlaceholder="'学歴を入力'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addEducationalHistory()"></el-button>
            </div>
          </div>
          <div class="attention-limit column" v-if="previewErrors.eduJobHistory">
            <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
          </div>
        </div>

      </div>
    </div>

    <div class="card" v-show="currentCardId == 'job-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>職歴を入力</h2>
          <p>「自動入力」を使うと、入社・退社表記を自動で作成できます。</p>
          <p v-if="formatId == 'rirekisho_hukugyo'">会社名を書きたくない場合は、「XX業界でのXX職」と書きましょう。</p>
          <el-checkbox v-model="formatData.notDisplayIjyo">【以上】を表示しない</el-checkbox>
        </div>
        <div class="card-content-list">
          <div class="edit-form-list">
            <div class="add-item">
              <auto-job-histories v-on:job-histories-created="setJobHistories" :birth-year="basicData.birthYear"
                :birth-month="basicData.birthMonth" :birth-day="basicData.birthDay"></auto-job-histories>
              <div class="button-reset">
                <el-button type="" v-if="formatData.jobHistories && formatData.jobHistories.length > 1"
                  @click="$modal.show('job-reset')">リセット</el-button>
              </div>
              <modal name="job-reset" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('job-reset');" icon="el-icon-close" type="text"></el-button>
                </div>
                <div class="title">職歴リセット</div>
                <span>現在入力されている職歴をすべて削除します。よろしいですか？</span>
                <div>
                  <el-button type="primary" @click="$modal.hide('job-reset'); resetJobHistories()">リセットする</el-button>
                  <el-button @click="$modal.hide('job-reset')">リセットしない</el-button>
                </div>
              </modal>
            </div>

            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addJobHistory" v-on:delete-history-item="deleteJobHistory"
                v-on:move-history-item="moveJobHistory" v-for="(item, index) in formatData.jobHistories"
                @click.native="activateHistoryItem(item.uuid)" :item="item" :length="formatData.jobHistories.length"
                :index="index" :key="item.uuid" :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }"
                :ref="'JobHistory_' + index" :minYear="basicData.birthYear" :createDate="formatData.createDate"
                :descriptionPlaceholder="'職歴を入力'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>

            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addJobHistory()"></el-button>
            </div>
            <div class="attention-limit column" v-if="previewErrors.eduJobHistory">
              <i class="el-icon-warning"></i>&ensp;{{ previewErrors.eduJobHistory }}
            </div>

            <div class="tips" v-if="formatId == 'rirekisho_job_change_old'">
              <details class="tips__accordion">
                <summary>履歴書の書き方ガイド</summary>
                <p><span style="font-weight: bold; color: #004D40;">① シンプルに書く</span><br>
                  基本的に雇用形態や職種、配属先などは記入不要です。職歴の具体的な成果は職務経歴書に記載し、履歴書はシンプルで見やすく記入していくのがおすすめです。<br><br>
                  退職理由を書く時は「一身上の都合により退職」と書くのが一般的で、具体的な理由は書かなくても問題ありません。
                </p>
              </details>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'license-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>免許・資格を入力</h2>
          <p>主要な免許・資格は例文から選ぶことができます</p>
          <el-checkbox v-model="formatData.notDisplayIjyoLicense">【以上】を表示しない</el-checkbox>
        </div>
        <div class="card-content-list">
          <div class="add-item">
            <el-button @click="$modal.show('license-dialog');" type="success">例文から追加</el-button>
            <modal name="license-dialog" :adaptive="true" :scrollable="true" height="auto">
              <div class="v--modal-close-top">
                <el-button @click="$modal.hide('license-dialog');" icon="el-icon-close" type="text"></el-button>
              </div>
              <div class="title">例文を選ぶ</div>
              <div class="description">
                <p>選択した例文が追加されます。</p>
              </div>
              <ul class="example-sentence">
                <li v-for="(item, index) in exampleSentences.license"
                  v-on:click="addLicenseHistory(null, { description: item }); $modal.hide('license-dialog');"
                  :key="index">
                  <div class="title">{{ index }}</div>
                  <div class="body" v-html="item"></div>
                </li>
              </ul>
              <div class="text-right">
                <el-button @click="$modal.hide('license-dialog');">閉じる</el-button>
              </div>
            </modal>
          </div>

          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addLicenseHistory" v-on:delete-history-item="deleteLicenseHistory"
                v-on:move-history-item="moveLicenseHistory" v-for="(item, index) in formatData.licenseHistories"
                @click.native="activateHistoryItem(item.uuid)" :item="item" :length="formatData.licenseHistories.length"
                :index="index" :key="item.uuid" :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }"
                :ref="'LicenseHistory_' + index" :minYear="basicData.birthYear" :createDate="formatData.createDate"
                :descriptionPlaceholder="'免許・資格を入力'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addLicenseHistory()"></el-button>
            </div>
            <div class="attention-limit column" v-if="previewErrors.licenseHistory">
              <i class="el-icon-warning"></i> {{ previewErrors.licenseHistory }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="currentCardId == 'reason'">
      <reason-card :format-id="formatId" :example-sentences="exampleSentences" :textarea-min-rows="textareaMinRows"
        :preview-errors="previewErrors" :format-data="formatData" @update:reason="value => formatData.reason = value"
        :current-card-id="currentCardId" />
    </div>

    <div class="card" v-show="currentCardId == 'reasonNew'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>自己PRを入力</h2>
          <p>{{ reasonLabel }}</p>
        </div>

        <div class="add-item">
          <el-button @click="$modal.show('reason-dialog')" type="success">例文から追加</el-button>
        </div>

        <div class="card-content">
          <modal name="reason-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('reason-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in exampleSentences.promotion"
                v-on:click="formatData.reasonNew += item.replace(/<br>/ig, '\n') + '\n'; $modal.hide('reason-dialog')"
                :key="index">
                <div class="title">{{ index }}</div>
                <div class="body" v-html="item"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('reason-dialog')">閉じる</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.reasonNew"
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"></el-input>
          <div class="attention-limit character" v-if="previewErrors.reasonNew">
            <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'hobby'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>趣味・特技を入力</h2>
          <p>{{ hobbyLabel }}</p>
        </div>

        <div class="add-item">
          <el-button @click="$modal.show('hobby-dialog')" type="success">例文から追加</el-button>
        </div>

        <div class="card-content">
          <modal name="hobby-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('hobby-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in exampleSentences.hobby"
                v-on:click="formatData.hobby += item.replace(/<br>/ig, '\n') + '\n'; $modal.hide('hobby-dialog')"
                :key="index">
                <div class="title">{{ index }}</div>
                <div class="body" v-html="item"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('hobby-dialog')">閉じる</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.hobby"
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"></el-input>
          <div class="attention-limit character" v-if="previewErrors.hobby">
            <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'requests'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>本人希望欄を入力</h2>
          <p>給与・職種・勤務時間・勤務地などの希望を入力します（任意）</p>
        </div>
        <div class="add-item">
          <el-button @click="$modal.show('request-dialog')" type="success">例文から追加</el-button>
        </div>

        <div class="card-content">

          <div class="edit-form-item">
            <div class="item-name">現在の年収</div>
            <div class="item-body">
              <el-input class="input-xs" placeholder="" title="現在の年収" type="number"
                v-model="formatData.nowNensyu"></el-input> 万円
            </div>
            <div class="item-name">希望年収</div>
            <div class="item-body">
              <el-input class="input-xs" placeholder="" title="希望年収" type="number"
                v-model="formatData.kibouNensyu"></el-input> 万円
            </div>
            <div class="item-name">※上記項目を入力した後、例文から追加ボタンをクリックして例文を選択すると自動的に反映されます。</div>
          </div>
          <br>
          <modal name="request-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('request-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">例文を選択すると、現在入力している文章は上書きされますのでご注意ください。</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in exampleSentences.request"
                v-on:click="formatData.request += item.replace(/<br>/ig, '\n').replace('OOO', formatData.nowNensyu).replace('XXX', formatData.kibouNensyu) + '\n'; $modal.hide('request-dialog');"
                :key="index">
                <div class="title">{{ index }}</div>
                <div class="body" v-html="item"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('request-dialog');">閉じる</el-button>
            </div>
          </modal>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 15 }" placeholder="給与・職種・勤務時間・勤務地など希望があれば入力"
            v-model="formatData.request">
          </el-input>
          <div class="attention-limit character" v-if="previewErrors.request">
            <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
          </div>
        </div>

      </div>
    </div>

    <div class="card" v-show="currentCardId == 'create-date'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>履歴書の作成日を入力</h2>
          <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
        </div>
        <div class="card-content">
          <div class="edit-form-list">
            <div class="create-date-action">
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getToday())"
                  @click="formatData.createDate = $formLib.getToday()">今日の日付を入力</el-button>
              </div>
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getTommorow())"
                  @click="formatData.createDate = $formLib.getTommorow()">明日の日付を入力</el-button>
              </div>
              <div class="action-item">
                <el-date-picker v-model="formatData.createDate" type="date" :clearable="false" placeholder="選択してください"
                  :format="'yyyy年M月d日'" ref="create_date">
                </el-date-picker>
              </div>
            </div>
          </div>
          <br>
          <div class="aiInterview_date" v-if="$globalVar.in_app_payments">
            <!--<p>履歴書を作成したら、面接の準備をしよう！</p>-->
            <a href="/yagiprimequickemail/info" class="aiInterview_lead" target="_blank" id="quickemailbnr_date_btn">
              <img src="/static/mypage/quickemailbnr.jpg" alt="メール便">
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'confirm'">
      <div class="overflow-scroll-y">
        <div class="card-header" stcyle="max-width: 40rem;margin: 2rem auto -3rem;">
          <h2>作成した履歴書を確認</h2>
          <p>修正する場合は、プレビューの修正欄をクリックまたはステップを戻ることで修正することができます</p>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'output'" v-if="getMode != 'production1'">

      <download-item :formatId="formatId" :isSendYagiPostEnabled="isSendYagiPostEnabled"
        :isSendYagiEmailEnabled="isSendYagiEmailEnabled" :mailPdfEnabled="mailPdfEnabled"
        :downloadPdfEnabled="downloadPdfEnabled" :downloadActiveCollapses="downloadActiveCollapses"
        @update:isSendYagiEmailEnabled="isSendYagiEmailEnabled = $event">
      </download-item>

    </div>


  </div>
</template>
<style lang="scss" scoped>

.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #EFF8F8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;
  font-family: "M PLUS Rounded 1c";
}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット 2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>
<style scoped>
.r-ai-format {
  border: 2px solid #8FBD67;
  border-radius: 10px;
  margin-top: 10px;
  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 225, 0, .25)), to(rgba(255, 225, 0, 0)));
  background-image: linear-gradient(180deg, rgba(255, 225, 0, .25), rgba(255, 225, 0, 0));
  margin-bottom: 10px;
  padding: 15px;
  width: 100%;
}

.r-ai-format .r-midashi {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: bold;
  color: rgb(255, 255, 255);
  background: rgb(15, 153, 52);
  border-radius: 15px;
  padding: 2px 10px;
  margin-bottom: 5px;
}

.r-ai-format .title {
  font-size: 1rem;
  line-height: 1.4;
  font-weight: 700;
}

.r-ai-format .r-form-title {
  margin-top: 10px;
  align-items: center;
}

.r-ai-format .r-form-title span {
  width: 10%;
  font-size: 0.8rem;
  margin-right: 5px;
}

.r-ai-format .r-txtarea {
  min-height: 36px;
  height: 36px;
}

.r-ai-format .r-btn-wrap {
  margin-top: 10px;
}

.r-ai-format .r-ai-btn {
  position: relative;
  color: rgb(255, 255, 255);
  background-color: #8FBD67;
  border-color: #8FBD67;
  overflow: hidden;
}

.r-ai-format .r-ai-btn::before {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
  background-image: linear-gradient(130deg, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 75%);
  -webkit-animation: shine 1s infinite;
  animation: shine 1s infinite;
}

@-webkit-keyframes shine {
  100% {
    left: 100%;
  }
}

@keyframes shine {
  100% {
    left: 100%;
  }
}

.r-ai-format .example-sentence li:hover {
  background: none;
}
</style>

<style scoped>
.yp-agent-register .card-header {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f8f8f8;
}

.yp-agent-register .yp-h2 {
  margin-bottom: 10px;
}

.yp-agent-register .card-content {
  border-top: none;
}

.yp-agent-register .yp-agent-list {
  margin-top: 20px;
}

.yp-agent-register .agent-logo {
  height: 50px;
  width: auto;
  margin-bottom: 10px;
  margin-right: 10px;
}

.yp-agent-register .agent-txt:last-child {
  margin-bottom: 10px;
}

.yp-agent-register .yp-agent-lead {
  color: #e3165c;
}

.yp-agent-register .yp-agent-memo {
  font-size: 0.75rem;
}

.yp-agent-register .consent-txt {
  align-items: center;
}

.yp-agent-register .consent-icon {
  width: auto;
  height: 16px;
  -o-object-fit: cover;
  object-fit: cover;
  margin-right: 5px;
}

.yp-agent-register .r-btn-wrap {
  margin-top: 10px
}

.yp-agent-register .r-ai-btn {
  position: relative;
  color: rgb(255, 255, 255);
  background-color: #8FBD67;
  border-color: #8FBD67;
  overflow: hidden;
}

.yp-agent-register .r-ai-btn::before {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
  background-image: linear-gradient(130deg, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 75%);
  -webkit-animation: shine 1s infinite;
  animation: shine 1s infinite;
}

@-webkit-keyframes shine {
  100% {
    left: 100%;
  }
}

@keyframes shine {
  100% {
    left: 100%;
  }
}
</style>

<style scoped>
.custom-modal {
  padding: 0px !important;
}

.ai-payment-card-box {
  display: flex;
  flex-direction: column;
}
</style>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.aiInterview_date {
  text-align: center;
}

.aiInterview_date {
  .aiInterview_lead {
    p {
      font-size: 0.75rem;
    }

    img {
      width: 350px;
      border-radius: 10px;

      @media screen and (max-width: 599px) {
        width: 100%;
      }

    }
  }
}

//tips
.tips {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;

  &__accordion {
    background: #eef5e8;
    border-radius: 6px;
    padding: 5px 10px;
    margin-bottom: 10px;
    font-size: 0.75rem;

    &:last-child {
      margin-bottom: 0;
    }

    summary {
      position: relative;
      color: #004D40;
      font-weight: bold;

      &::after {
        position: absolute;
        content: "";
        background-image: url(/static/img/closebtn.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        width: 15px;
        height: 15px;
        right: 0;
      }
    }

    &:not([open]) {
      summary {
        &::after {
          background-image: url(/static/img/openbtn.svg);
          right: -15px;
          top: -5px;
        }
      }
    }
  }
}

.guidetxt {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
}

.guideimg {
  display: block;
  width: 70%;
  margin: 0 auto 20px;

  @include max-width(sm) {
    width: 100%;
  }

}

.id-old-txt {
  font-weight: bold;
  text-align: center;
}
</style>
<script>
import HistoryItem from './RirekishoParts/HistoryItem'
import DownloadItem from './CommonParts/DownloadItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginSpecialForms'
import { loadStripe } from '@stripe/stripe-js'
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import City from '@/plugins/tryt-city-master'
import YagiprimeWrapper from '@/components/Payment/YagiprimeWrapper.vue'
import ReasonCard from '../yagiprime/ReasonCard.vue'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
export default {
  name: 'RirekishoEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'download-item': DownloadItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms,
    StripeElementCard,
    YagiprimeWrapper,
    ReasonCard
  },
  data: function () {
    return {
      isPaymentYagiprime: true,
      completeBuyYagiprime: false,
      fullscreenLoading: false,
      loadingText: 'AIがあなたに最適なテキストを生成しています',
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      matchingCompany: {},
      isMatching: false,
      trytCity: City,
      paymentMethod: 'card',
      paymentMethodTab: 'card',
      isApplePayAvailable: false,
      saveName: 'rirekisho',
      saveOtherName: 'shokumukeirekisho',
      activeName: '1',
      viewYagiprimepayment: false,
      hopeIndustryOptions: ['', 'IT・通信', 'ソフトウェア・情報処理', 'インターネット関連・ゲーム・アプリ関連', '機械・産業用装置・電機・OA機器', '自動車・自動車部品・輸送用機器', 'コンピュータ・通信機器・精密機器', '電子部品・半導体', '食品・飲料・たばこ・飼料', '化学・医薬・化粧品', '鉄鋼・非鉄金属・金属製品', '石油・石炭・ゴム・プラスチック', 'ガラス・セラミック・セメント', 'パルプ・紙・紙加工・印刷・印刷関連', '日用品・文具・オフィス用品', '建材・エクステリア', 'インテリア・住宅関連', 'アパレル・服飾関連', 'スポーツ・玩具・ゲーム機器', 'その他メーカー・製造関連', '電気・ガス・石油・水道', '放送（テレビ・ラジオ含む）', '新聞・出版', '広告', 'その他（芸能・エンタテインメント関連等）', '運輸（鉄道・航空・海運・物流等）', '総合商社', '専門商社', '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター', '通信販売、専門店・その他小売り', '銀行（協同組織金融含む）', '証券', '保険', 'その他金融（クレジット等）', 'リース・レンタル', 'ディベロッパー', '建設・建築設計・ハウスメーカー', '設備関連', 'プラント・プラントエンジニアリング', '不動産取引・不動産賃貸・不動産管理', 'デザイン・芸術関連', 'コンサルティング・マーケティング・調査', 'その他専門・技術サービス', 'ホテル・旅館', '外食', 'その他フード', '理美容・エステ・フィットネスクラブ', '旅行・観光', '家事サービス・クリーニング', '冠婚葬祭', 'その他生活関連サービス', 'アミューズメント・レジャーサービス', '教育関連', '医療・保育・介護、福祉', '環境・リサイクル・廃棄物処理', '整備・修理', '人材サービス', 'その他事業サービス（警備、コールセンター等）', 'その他'],
      hopeCareerJobcategoryOptions: ['', '営業', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業'],

      formatData: {
        createDate: null,
        educationalHistories: [],
        jobHistories: [],
        lastestEdu: '',
        lastestJob: '',

        licenseHistories: [],
        commuteDescription: '',
        commuteHours: '',
        commuteMinutes: '',
        spouseNumber: '',
        hasSpouse: false,
        underDutyToSupport: false,
        reason: '',
        reasonNew: '',
        hobby: '',
        request: '',
        nowNensyu: '',
        kibouNensyu: '',
        requestStatement: '',
        shogaiLevel: '',
        shogaiKind: '',
        handbookKind: '',
        hospitalVisit: '',
        hospitalVisitDescription: '',
        skillDescription: '',
        disorderFeature: '',
        selfDisorderFeature: '',
        considerationDesired: ''
      },
      handbookKindOptions: [
        { value: '身体障害者手帳', label: '身体障害者手帳' },
        { value: '療育手帳', label: '療育手帳' },
        { value: '精神障害者保健福祉手帳', label: '精神障害者保健福祉手帳' }
      ],
      selectAlliancesOptions: [
        { value: '障がい福祉イノベーション', label: '障がい福祉イノベーション' },
        { value: '広告やメディア', label: '広告やメディア' },
        { value: '障がい者から依頼', label: '障がい者から依頼' },
        { value: 'その他', label: 'その他' }
      ],
      disorderFeatureStatement: {
        '特性①': '急ぎの作業の際にケアレスミスが起きやすい',
        '特性②': '過集中傾向があり、話しかけられても気づかない時がある。',
        '特性③': 'マルチタスクが苦手'
      },
      selfDisorderFeatureStatement: {
        '自己対応①': 'Wチェックの徹底を行い、納品時に第三者のチェックをお願いする',
        '自己対応②': '適度な小休憩で過集中を防ぐ',
        '自己対応③': '作業開始前にタスク整理を行い、各作業を時間単位で区切り、マルチタスクに対応する'
      },
      considerationDesiredStatement: {
        '配慮①': '通院配慮：月に1度、第三火曜日に通院のため、午前休を頂ければ幸いです。',
        '配慮②': '過度な残業：残業は月に約5時間以内をお願いできればと思います。',
        '配慮③': '相談環境：業務で悩んだ際に相談しやすい環境があれば幸いです。'
      },
      shogaiKindOptions: [],
      shogaiKindOptionTemps: {
        first: [
          { value: '視覚障害', label: '視覚障害' },
          { value: '聴覚または平衡機能の障害', label: '聴覚または平衡機能の障害' },
          { value: '音声機能', label: '音声機能' },
          { value: '言語機能またはそしゃく機能の障害', label: '言語機能またはそしゃく機能の障害' },
          { value: '肢体不自由（車椅子あり）', label: '肢体不自由（車椅子あり）' },
          { value: '肢体不自由（車椅子なし）', label: '肢体不自由（車椅子なし）' },
          { value: '心臓機能の障害', label: '心臓機能の障害' },
          { value: 'じん臓機能の障害', label: 'じん臓機能の障害' },
          { value: '呼吸器機能の障害', label: '呼吸器機能の障害' },
          { value: 'ぼうこうまたは直腸の機能の障害', label: 'ぼうこうまたは直腸の機能の障害' },
          { value: '小腸の機能の障害', label: '小腸の機能の障害' },
          { value: 'ヒト免疫不全ウイルスによる免疫の機能の障害', label: 'ヒト免疫不全ウイルスによる免疫の機能の障害' },
          { value: '肝臓の機能の障害', label: '肝臓の機能の障害' },
          { value: 'その他', label: 'その他' }
        ],
        second: [
          { value: '知的障害', label: '知的障害' },
          { value: 'その他', label: 'その他' }
        ],
        third: [
          { value: '統合失調症', label: '統合失調症' },
          { value: 'うつ病、双極性障害（躁うつ病）などの気分障害', label: 'うつ病、双極性障害（躁うつ病）などの気分障害' },
          { value: '非定型精神病', label: '非定型精神病' },
          { value: 'てんかん', label: 'てんかん' },
          { value: '中毒精神病', label: '中毒精神病' },
          { value: '高次脳機能障害', label: '高次脳機能障害' },
          { value: '発達障害', label: '発達障害' },
          { value: 'その他の精神疾患など', label: 'その他の精神疾患など' },
          { value: 'その他', label: 'その他' }
        ]
      },
      shogaiLevelOptions: [],
      shogaiLevelOptionTemps: {
        first: [
          { value: '1級', label: '1級' },
          { value: '2級', label: '2級' },
          { value: '3級', label: '3級' },
          { value: '4級', label: '4級' },
          { value: '5級', label: '5級' },
          { value: '6級', label: '6級' },
          { value: '7級', label: '7級' },
          { value: '手帳取得中', label: '手帳取得中' }
        ],
        second: [
          { value: '最重度（A判定）', label: '最重度（A判定）' },
          { value: '重度（A判定）', label: '重度（A判定）' },
          { value: '中度（B判定）', label: '中度（B判定）' },
          { value: '軽度（B判定）', label: '軽度（B判定）' },
          { value: 'それ以外（B判定）', label: 'それ以外（B判定）' },
          { value: '手帳取得中', label: '手帳取得中' }
        ],
        third: [
          { value: '1級', label: '1級' },
          { value: '2級', label: '2級' },
          { value: '3級', label: '3級' },
          { value: '手帳取得中', label: '手帳取得中' }
        ]
      },
      isWeekEndFlag: true,
      activeHistoryItem: '',
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      isSendYagiEmailEnabled: true,
      previewScale: 1,
      previewViewerCss: {},
      isNew: false,
      textareaMinRows: 3,
      reasonLabel: '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！',
      hobbyLabel: '人柄も大切。趣味・特技であなたの個性をアピールしましょう！',
      downloadActiveCollapses: ['postcard'],
      gradeYearOptions: [
        {
          value: '23',
          label: '23年卒'
        },
        {
          value: '24',
          label: '24年卒'
        },
        {
          value: '99',
          label: 'その他'
        }
      ],
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      relationshipOptions: [
        {
          value: '就労支援施設職員',
          label: '就労支援施設職員'
        }
        // {
        //   value: '両親・保護者',
        //   label: '両親・保護者'
        // },
        // {
        //   value: '友人・知人',
        //   label: '友人・知人'
        // },
        // {
        //   value: 'その他',
        //   label: 'その他'
        // }
      ],
      exampleRequestSentences: {
        // 志望動機
        request_statement: {
          '': 'お世話になっています。\nこの度は、私の推薦文を書いていただきたいと思っております。\nご多忙の中、恐縮ですがお力添えの程、何卒よろしくお願いいたします。'
        }
      },
      isCampaign: false,
      isCampaign4Me: false,
      trial_campaign_id: 0,
      aiResultView: false
    }
  },

  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return (this.$yagi.isFromMynabi === 1)
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    getLicences: function () {
      let licensesStr = ''
      for (const key in this.formatData.licenseHistories) {
        licensesStr = licensesStr + this.formatData.licenseHistories[key].description + ','
      }
      return licensesStr
    }
  },
  methods: {
    loading_on: function () {
      this.fullscreenLoading = true
    },
    loading_off: function () {
      this.fullscreenLoading = false
      this.completeBuyYagiprime = true
    },
    viewPaymentYagiprime: function () {
      this.viewYagiprimepayment = true
      this.initializeExpressCheckout()
    },
    paymentYagiprime: function () {
      console.error(this.paymentMethod)
      const app = this
      if (app.isPaymentYagiprime && this.paymentMethod === 'card') {
        this.$refs.stripeCardElememt.submit()
      }
    },
    tokenCreated(token, merchantPaymentId = '') {
      const app = this
      app.fullscreenLoading = true
      app.isPaymentYagiprime = false
      app.$eventHub.$emit('loading_on')
      this.token = ''
      if (token) {
        this.token = token.id
      }
      if (merchantPaymentId) {
        this.paymentMethodTab = 'paypay'
      }
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)

      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('payment_method', this.paymentMethodTab)
      if (app.isCampaign) {
        formData.append('trial_campaign_id', app.trial_campaign_id)
      }
      this.$axios
        .post(this.$varuna.endPoints.subscription, formData, { timeout: 60000 })
        .then(function (response) {
          if (response.status === 201) {
            app.completeBuyYagiprime = true
            app.$globalVar.isYagiPrime = true
            const subformData = new FormData()
            subformData.append('route', 'rirekisho_ai_career')
            subformData.append('uuid', app.$firebase.user.uid)
            app.$axios
              .post(app.$varuna.endPoints.setYagiprimeEntrySource, subformData, { timeout: 60000 })
            app.$message({
              message: '購入完了しました',
              type: 'success'
            })
            formData.append('current_location', app.getPrefName(app.basicData.address1))
            formData.append('preferred_job', app.formatData.hopeJobcategory)
            formData.append('app_flag', app.$site.appFlag)
            formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            formData.append('version', '3')
            formData.append('site_flag', 'r')
            formData.append('age', app.basicData.age)
            formData.append('applicant_type_id', '2')
            app.$axios
              .post(app.$varuna.endPoints.primeAdditionalInfo, formData, { timeout: 60000 })
              .then(function (response) {
                console.error(response.data)
                if (response.data.success) {
                  app.matchingCompany = response.data.matching_company
                  app.isMatching = response.data.is_matching
                }
              })
              .catch(function () {
              }).finally(function () {
                app.fullscreenLoading = false
              })
          }
        })
        .catch(function () {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    yagiprimePaypay: function (param) {
      const app = this
      app.fullscreenLoading = true

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)

      var routeId = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      if (routeId) {
        formData.append('route', routeId)
      } else {
        formData.append('route', '')
      }
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('redirect_url', window.location.href)

      this.$axios
        .post(this.$varuna.endPoints.paypaySubscriptions, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.authorization_url)
          location.href = response.data.authorization_url
        })
        .catch(function () {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    getPrefName: function (address) {
      for (const key in this.trytCity.prefs) {
        if (address && address.indexOf(this.trytCity.prefs[key]) >= 0) {
          return this.trytCity.prefs[key]
        }
      }
      return ''
    },
    async initializeExpressCheckout() {
      const stripe = await loadStripe(this.publishableKey)
      const AMOUNT = 550
      const CURRENCY = 'jpy'
      const LABEL = 'ヤギプライム'

      // Apple Pay の paymentRequest を作成または取得
      if (!this.paymentRequest) {
        this.paymentRequest = stripe.paymentRequest({
          country: 'JP',
          currency: CURRENCY,
          total: {
            label: LABEL,
            amount: AMOUNT
          },
          requestPayerName: true,
          requestPayerEmail: true
        })

        // Apple Pay が利用可能か確認
        const result = await this.paymentRequest.canMakePayment()
        console.log('Apple Pay 利用可能:', result)
        this.isApplePayAvailable = !!(result && result.applePay)
      }
    },
    async mountExpressCheckoutElement() {
      await this.$nextTick() // DOMが更新されるのを待つ
      if (!this.expressCheckoutElement) {
        this.loadingText = ''
        this.fullscreenLoading = true
        const stripe = await loadStripe(this.publishableKey)
        const AMOUNT = 550
        const CURRENCY = 'jpy'
        const LABEL = 'ヤギプライム'
        const elements = stripe.elements({
          mode: 'subscription',
          amount: AMOUNT,
          currency: CURRENCY
        })

        console.log('Customerの作成開始')
        const customerForm = new FormData()
        customerForm.append('uuid', this.$firebase.user.uid)
        customerForm.append('subscription_type', 1)
        var routeId = this.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
        if (routeId) {
          customerForm.append('route', routeId)
        } else {
          customerForm.append('route', '')
        }

        const response = await this.$axios.post(this.$varuna.endPoints.createStripeCustomer, customerForm)

        console.log('Customerの作成成功:', response.data.success)
        console.log('IncompleteSubscriptionの作成成功:', response.data.client_secret)

        this.clientSecret = response.data.client_secret

        this.expressCheckoutElement = elements.create('expressCheckout', {
          paymentRequest: this.paymentRequest
        })

        this.expressCheckoutElement.mount('#payment-request-button')
        this.fullscreenLoading = false

        this.expressCheckoutElement.on('click', (e) => {
          const options = {
            clientSecret: this.clientSecret,
            applePay: {
              recurringPaymentRequest: {
                paymentDescription: LABEL,
                regularBilling: {
                  amount: AMOUNT,
                  label: LABEL,
                  recurringPaymentIntervalUnit: 'day',
                  recurringPaymentIntervalCount: 30
                },
                billingAgreement:
                  '30日間ごとに550円(税込)となります。\n本サービスにお申込みいただき、お客様の登録が完了した時点でご利用代金が引き落とされると同時に、サービスが開始されます。\n初回のサービス提供期間終了後、自動更新され、お客様の選択により、以降30日間ごとに550円（税込）がかかります。\n利用代金は更新されたサービス期間の毎初日に登録された決済情報から引き落とされます。\nお申込み手続きの完了後に、代金の返金やキャンセルはできません。※解約はマイページの「アカウント情報」からお申込みいただけます。',
                managementURL: 'https://rirekisho.yagish.jp/mypage/account'
              }
            }
          }
          e.resolve(options)
        })

        this.expressCheckoutElement.on('confirm', async (event) => {
          try {
            console.log('フォームのデータを送信開始')
            const { error: submitError } = await elements.submit()
            if (submitError) {
              console.error('フォーム送信エラー:', submitError)
              this.$message({
                message: submitError.message,
                type: 'error'
              })
              event.complete('fail')
              return
            }
            console.log('PaymentIntentの確認開始')
            const { error: confirmError } = await stripe.confirmPayment({
              elements,
              clientSecret: this.clientSecret,
              confirmParams: {
                return_url: window.location.href
              }
            })
            console.log(confirmError)
          } catch (error) {
            console.error('支払いエラー:', error)
            this.$message({
              message: '支払いに失敗しました。',
              type: 'error'
            })
            event.complete('fail')
          }
        })
      }
    },
    getAIMypr: function () {
      const app = this
      // console.error(app.formatData.educationalHistories.length)
      // console.error(app.formatData.educationalHistories[app.formatData.educationalHistories.length - 1].description)
      // return
      app.fullscreenLoading = true
      const formData = new FormData()
      if (app.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }
      formData.append('education', app.formatData.lastestEdu)
      formData.append('job', app.formatData.lastestJob)
      formData.append('licenses', app.getLicences)
      formData.append('strength', app.formatData.ai_strength)
      formData.append('company_name', app.formatData.ai_company_name)
      formData.append('company_industry', app.formatData.hopeIndustrycategory)
      formData.append('company_job', app.formatData.hopeJobcategory)

      this.$axios
        .post(this.$varuna.endPoints.aiIntroducePr, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.success)
          if (response.data.success) {
            app.aiResultMyprResult = response.data.message
            app.aiResultView = true
            app.$message({
              message: '取得しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error.response.data.message)
          if (error.response.data.message === 'AIの使用回数が上限に達しました。') {
            app.aiResultView = true
          }
          if (error.response.data.message) {
            app.$message({
              message: error.response.data.message,
              type: 'error'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        }).finally(function () {
          app.fullscreenLoading = false
        })

      this.$axios
        .post(this.$varuna.endPoints.aiIntroduceReason, formData, { timeout: 60000 })
        .then(function (response) {
          if (response.data.success) {
            app.aiResultReasonResult = response.data.message
            app.aiResultView = true
            app.$message({
              message: '取得しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error.response.data.message)
          if (error.response.data.message) {
            app.$message({
              message: error.response.data.message,
              type: 'error'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    getAIMyprX: function () {
      const app = this
      // console.error(app.formatData.educationalHistories.length)
      // console.error(app.formatData.educationalHistories[app.formatData.educationalHistories.length - 1].description)
      // return
      app.fullscreenLoading = true
      const formData = new FormData()
      if (app.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }
      if (app.formatData.educationalHistories.length > 0) {
        formData.append('education', app.formatData.educationalHistories[app.formatData.educationalHistories.length - 1].description)
      } else {
        formData.append('education', '')
      }
      formData.append('strength', this.formatData.ai_mypr_good)
      formData.append('weakness', this.formatData.ai_mypr_bad)
      formData.append('hobby', this.formatData.ai_mypr_hobby)
      formData.append('future', this.formatData.ai_mypr_wanted)
      formData.append('free', this.formatData.ai_mypr_appeal)

      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')

      this.$axios
        .post(this.$varuna.endPoints.aiIntroduce, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.success)
          if (response.data.success) {
            app.aiResultMyprResult = response.data.message
            app.aiResultView = true
            app.$message({
              message: '取得しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error.response.data.message)
          if (error.response.data.message) {
            app.$message({
              message: error.response.data.message,
              type: 'error'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    applyAgent: function () {
      const app = this
      var isCheck = true

      if (isCheck) {
        app.fullscreenLoading = true

        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        if (this.matchingCompany) {
          formData.append('company_uid', this.matchingCompany.company_uid)
          formData.append('category', this.matchingCompany.category)
        }
        formData.append('is_matching', this.isMatching)

        // eslint-disable-next-line no-constant-condition
        if (true) {
          formData.append('applicant_type_id', 2)
          formData.append('app_flag', this.$site.appFlag)
          formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
          formData.append('version', '3')
          formData.append('site_flag', 'r')
          this.$axios
            .post(this.$varuna.endPoints.applyAgent, formData, { timeout: 60000 })
            .then(function (response) {
              console.error(response.data)
              if (response.data.success) {
                app.$message({
                  message: '更新完了しました',
                  type: 'success'
                })
                // app.goCardTo('complete')
                app.viewYagiprimepayment = true
                app.$eventHub.$emit('go-card-to', 'output')
              }
            })
            .catch(function () {
              app.$message({
                message: '更新失敗しました',
                type: 'error'
              })
            }).finally(function () {
              app.fullscreenLoading = false
            })
        }
      }
    },
    selectHandbookKind: function () {
      if (this.formatData.handbookKind === '身体障害者手帳') {
        this.shogaiKindOptions = this.shogaiKindOptionTemps.first
        this.shogaiLevelOptions = this.shogaiLevelOptionTemps.first
      }
      if (this.formatData.handbookKind === '療育手帳') {
        this.shogaiKindOptions = this.shogaiKindOptionTemps.second
        this.shogaiLevelOptions = this.shogaiLevelOptionTemps.second
      }
      if (this.formatData.handbookKind === '精神障害者保健福祉手帳') {
        this.shogaiKindOptions = this.shogaiKindOptionTemps.third
        this.shogaiLevelOptions = this.shogaiLevelOptionTemps.third
      }
      this.formatData.shogaiKind = ''
      this.formatData.shogaiLevel = ''
    },
    setEducationalBackgrounds: function (historyList) {
      this.formatData.educationalHistories = []
      // 常に先頭から追加
      let index = 0
      for (let key in historyList) {
        let item = historyList[key]
        this.addEducationalHistory(index++, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    addExampleSentences: function (selectedSentences, modal) {
      let tArea = this.$refs.yourTextarea
      let startPos = tArea.selectionStart
      let endPos = tArea.selectionEnd
      let tmpStr = tArea.value
      console.error(tArea)
      console.error(startPos)
      this.formatData.reasonNew = tmpStr.substring(0, startPos) + selectedSentences + tmpStr.substring(endPos, tmpStr.length)
      modal.hide('reason-dialog')
      modal.hide('hobby-dialog')
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (let key in historyList) {
        let item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetEducationalBackgrounds: function () {
      this.formatData.educationalHistories = []
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new HistoryData(columns.year, columns.month, columns.description)
    },
    addHistory: function (historyList, index, refId, columns) {
      const newHistoryItem = this.createHistoryItem(columns)
      console.error(historyList)
      if (historyList == null) {
        // eslint-disable-next-line no-array-constructor
        historyList = new Array()
      }
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    updateLastestEduFromHistories: function () {
      if (!this.formatData || !this.formatData.educationalHistories || this.formatData.educationalHistories.length === 0) {
        this.formatData.lastestEdu = ''
        return
      }
      const sorted = this.sortHistory(this.formatData.educationalHistories)
      const valid = sorted.filter(function (item) {
        const year = Number(item.year)
        const month = Number(item.month)
        return year && month
      })
      const latest = valid.length > 0 ? valid[valid.length - 1] : null
      this.formatData.lastestEdu = latest && latest.description ? latest.description : ''
    },
    updateLastestJobFromHistories: function () {
      if (!this.formatData || !this.formatData.jobHistories || this.formatData.jobHistories.length === 0) {
        this.formatData.lastestJob = ''
        return
      }
      const sorted = this.sortHistory(this.formatData.jobHistories)
      const valid = sorted.filter(function (item) {
        const year = Number(item.year)
        const month = Number(item.month)
        return year && month
      })
      const latest = valid.length > 0 ? valid[valid.length - 1] : null
      this.formatData.lastestJob = latest && latest.description ? latest.description : ''
    },

    addEducationalHistory: function (index, columns) {
      if (this.formatData.educationalHistories == null) {
        this.$set(this.formatData, 'educationalHistories', [])
      }
      this.addHistory(this.formatData.educationalHistories, index, 'EducationalHistory_', columns)
    },
    moveEducationalHistory: function (params) {
      this.moveHistory(this.formatData.educationalHistories, params)
    },
    addJobHistory: function (index, columns) {
      if (this.formatData.jobHistories == null) {
        this.$set(this.formatData, 'jobHistories', [])
      }
      this.addHistory(this.formatData.jobHistories, index, 'JobHistory_', columns)
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    addLicenseHistory: function (index, columns) {
      if (this.formatData.licenseHistories == null) {
        this.$set(this.formatData, 'licenseHistories', [])
      }
      this.addHistory(this.formatData.licenseHistories, index, 'LicenseHistory_', columns)
    },
    moveLicenseHistory: function (params) {
      this.moveHistory(this.formatData.licenseHistories, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
      } else if (to === 'down') {
        historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteEducationalHistory: function (index) {
      this.formatData.educationalHistories.splice(index, 1)
    },
    sendQuickmailLP: function () {
      location.href = '/quickmail/info'
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteLicenseHistory: function (index) {
      this.formatData.licenseHistories.splice(index, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    },
    authStateChanged: async function () {
      // 非ログイン時は処理をスキップ
      if (!this.$firebase || !this.$firebase.user) {
        return
      }
      const app = this
      if (app.$firebase.user && app.$firebase.isAuthenticated) {
        app.fullscreenLoading = true
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        this.$axios
          .post(this.$varuna.endPoints.canUseTrialCampaign, formData, { timeout: 60000 })
          .then(function (response) {
            console.error(response.data.can_use_trial_campaign)
            if (response.data.can_use_trial_campaign) {
              app.isCampaign4Me = true
            } else {
              app.isCampaign4Me = false
              app.isCampaign = false
              app.trial_campaign_id = null
            }
          })
          .catch(function () {
          }).finally(function () {
            app.fullscreenLoading = false
          })
      }
    },
    changeLoadingText: function (text) {
      this.loadingText = text
    },
    // ヤギメール送信ボタンクリック時の処理
    handleYagiEmailClick: function (eventName, formatId) {
      // 状態を無効化
      this.isSendYagiEmailEnabled = false
      // イベントを発火
      this.$eventHub.$emit(eventName, formatId)
    }
  },
  watch: {
    'formatData.createDate': function (newValue, oldValue) {
      this.formatData.writeDate = this.$formLib.dateFormat(newValue, 'yyyy年 m月 d日')
    },
    paymentMethodTab: function (val) {
      if (val === 'applepay') {
        this.mountExpressCheckoutElement()
      } else {
        this.expressCheckoutElement.unmount()
        this.expressCheckoutElement = null
      }
    },
    'formatData.educationalHistories': {
      handler() {
        this.updateLastestEduFromHistories()
      },
      deep: true,
      immediate: true
    },
    'formatData.jobHistories': {
      handler() {
        this.updateLastestJobFromHistories()
      },
      deep: true,
      immediate: true
    }
  },
  created: function () {
    const app = this

    this.$axios
      .get(this.$varuna.endPoints.getTrialCampaign, null, { timeout: 60000 })
      .then(function (response) {
        console.error(app.isCampaign)
        console.error(response.data[0])
        const today = new Date() // 本日の日付
        const startDate = new Date(response.data[0].trial_campaign_start_date)
        const endDate = new Date(response.data[0].trial_campaign_end_date)

        // キャンペーンが有効かつ、本日がキャンペーン期間内かを確認
        if (response.data[0].trial_campaign_is_active && today >= startDate && today <= endDate) {
          app.isCampaign = true
          app.trial_campaign_id = response.data[0].trial_campaign_id
        }
        console.error(app.isCampaign)
      })
      .catch(function () {
      }).finally(function () {
        app.fullscreenLoading = false
      })

    const nowdate = new Date()
    const date1 = new Date('2023/05/27 00:00:00')
    const date2 = new Date('2023/05/28 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    if (this.getMode !== 'production') {
      this.isWeekEndFlag = true
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    if (this.formatId === 'rirekisho_job_new') {
      this.textareaMinRows = 10
    }
    if (this.formatId === 'rirekisho_job_new_single') {
      this.textareaMinRows = 6
    }
    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
    this.$eventHub.$on('loading_on', this.loading_on)
    this.$eventHub.$on('loading_off', this.loading_off)
    this.$eventHub.$on('change-loading-text', this.changeLoadingText)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
    this.$eventHub.$off('loading_on', this.loading_on)
    this.$eventHub.$off('loading_off', this.loading_off)
    this.$eventHub.$off('change-loading-text', this.changeLoadingText)
  }
}
</script>
